<nz-layout>
  <nz-content
    ><ng-container>
      <app-reusable-table
        title="Current Medication"
        [columns]="[
          'Period',
          'Product',
          'Package',
          'Unit',
          'Frequency',
          'Duration',
          'Scheduled Days',
        ]"
        [rowFields]="[
          'periodCombination',
          'productCombination',
          'packageCombination',
          'unitCombination',
          'frequencyCombination',
          'durationTreatmentCombination',
          'scheduledDaysCombination',
        ]"
        [data]="currentMedication?.getAll"
        [dataGetList]="currentMedication"
        [isLoading]="isLoading"
        [expandComponent]="expandComp"
        [isNoKnownLoading]="isNoKnownLoading"
        [deleteFun]="deleteFun"
        [stopFun]="stopFun"
        [handleToggleFun]="handleToggleFun"
        [openModalFun]="openModalFun"
        [customActions]="customActions"
        [isPreview]="false"
        [addPermissions]="['a-med']"
        [stopPermissions]="['s-med']"
      />
    </ng-container>
  </nz-content>
</nz-layout>
